const TAB_ID_KEY = 'checTabId'

// Fallback for browsers without crypto.randomUUID (IE11 support per browserslist)
const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  // Bitwise operations required for UUID generation algorithm
  /* eslint-disable no-bitwise */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
  /* eslint-enable no-bitwise */
}

export const getTabId = () => {
  let tabId = sessionStorage.getItem(TAB_ID_KEY)
  if (!tabId) {
    tabId = generateUUID()
    sessionStorage.setItem(TAB_ID_KEY, tabId)
  }
  return tabId
}
